import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'TipsInfo',
  props: {
  role: {
    type: String,
    required: true,
    default: ''
  }
},
  setup(__props) {

const props = __props



const message = computed(() => {
  if (props.role === 'waiter') { return 'официанту' }
  if (props.role === 'hookah') { return 'кальянщику' }
  if (props.role === 'barman') { return 'бармену' }
  if (props.role === 'barista') { return 'бариста' }
  if (props.role === 'sommelier') { return 'сомелье' }
  return ''
})

return { __sfc: true,props, message }
}

})